// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__3Bda5","dragIcon":"Choice_dragIcon__Lft-g","left":"Choice_left__3IDuH","input":"Choice_input__1Ds30"};